import React from 'react';
import Fade from '@smart-tv/components/fade/fade';

import { LiveTvChannel } from '@smart-tv/typings/content';
import PlayerLoadingInfo from './player-loading-info';
import PlayerLoadingSpinner from './player-loading-spinner';
import PlayerLoadingBackground from './player-loading-background';
import usePlayerLoading from './use-player-loading';
import useVodPlayer from '../vod-wrapper/_hooks/use-vod-player';
import ProgramSheetSkeleton from '@smart-tv/components/program-sheet/components/program-sheet-skeleton';
import styles from './player-loading.module.scss';

interface Props {
  channel?: LiveTvChannel;
  setChannel: (value?: LiveTvChannel) => void;
  mediaId?: number;
  eventId?: number;
  contentId?: number;
}

export const PlayerLoading: React.FC<Props> = (props: Props) => {
  const { channel, mediaId, eventId, contentId } = props;
  const { playerIsClosing, playerIsClosingToSheet } = useVodPlayer();

  const { playerWaiting, loadingRootRef, showSpinner } = usePlayerLoading({
    channel,
    mediaId,
    eventId,
    contentId
  });

  return (
    <Fade in={true} unmountOnExit>
      <div ref={loadingRootRef} className={styles['player-loading']}>
        <PlayerLoadingBackground playerWaiting={playerWaiting} playerIsClosing={playerIsClosing} />
        {playerIsClosingToSheet ? (
          <ProgramSheetSkeleton />
        ) : (
          showSpinner && <PlayerLoadingSpinner playerWaiting={playerWaiting} />
        )}
        {!playerIsClosingToSheet && <PlayerLoadingInfo channel={channel} />}
      </div>
    </Fade>
  );
};

export default React.memo(PlayerLoading);
